import {StyleSheet} from "aphrodite";

import {addStyle} from "@khanacademy/wonder-blocks-core";

import type {JsonPath} from "../../types.ts";
import {isPlaceholder} from "../../utils.ts";
import PlaceholderBlock from "../placeholder-block.tsx";

import CellNode from "./cell-node.tsx";
import type {RowData} from "./types.ts";

const StyledTr = addStyle("tr");

interface Props {
    cells: RowData["cells"];
    path: JsonPath;
}

export default function RowNode({cells, path}: Props) {
    return (
        <StyledTr style={styles.tr}>
            {cells.map((cell, i) => {
                if (isPlaceholder(cell)) {
                    return (
                        <PlaceholderBlock
                            key={i}
                            placeholderKey={cell.$placeholder}
                        />
                    );
                }

                return (
                    <CellNode
                        key={i}
                        kind={cell.kind}
                        content={cell.content}
                        path={[...path, "cells", `${i}`]}
                    />
                );
            })}
        </StyledTr>
    );
}

const styles = StyleSheet.create({
    tr: {
        display: "table-row",
    },
});
